<template>
  <div>
    <DynamicToggleCollapse :titles="[{id:'Device-filter',name:'Device filter'}]">
      <b-collapse id="Device-filter">
        <b-card>
          <DevicesListFilters @divicesFilterd="divicesFilterd" @merageFilterWithRequest="merageFilterWithRequest" />
        </b-card>
      </b-collapse>


    </DynamicToggleCollapse>

    <!-- form report -->
    <b-card style="position: relative">

      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="getReport" class="">

        <b-row class="mt-2">

          <!-- devices  -->
          <b-col cols="6">
            <b-form-group :label="$t('Devices')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.devices" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{name: $t('all'), id: 'all'},...devices]"
                :reduce="d => d.id" />
              <small v-if="errors && ('devices' in errors)" class="text-danger">
                {{ $t(errors['devices'][0]) }}
              </small>
            </b-form-group>
          </b-col>



          <b-col md="6" sm="6">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="YYYY-MM-DD" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{('from' in errors) ? errors['from'][0] : '' }}
                {{('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>





        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <div v-if="report_data">
      <DataTable :report_data="report_data" :report_fields="report_fields"
        :filter_included_fields="filter_included_fields" :request="request" :errors="errors" :loading="dataTableloading||loading"
        :getReport="getReport" :total="total" :from="from" :to="to"  :sortData="sortData"/>

    </div>

  </div>
</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BCollapse
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref } from '@vue/composition-api'

import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'

import reportForm from '@/app/reports/supportCompactor/reportForm'
import ReportLogic from '@/app/reports/supportCompactor/logic'
import DevicesListFilters from './DevicesListFilters.vue'
import FilterLogic from './filterLogic.js'

import DynamicToggleCollapse from '@/views/ui/toggle-collapse/DynamicToggleCollapse.vue'
import ReportOptions from '@/views/reports/components/options.js'
import DataTable from '@/views/reports/data-table/DataTable.vue'
export default {
  name: 'RainReport',
  components: {
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination, BCollapse,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    DevicesListFilters,
    DynamicToggleCollapse,
    DataTable,


  },
  directives: { Ripple, },

  setup(props, { root }) {
    const getRowClass = (item, r) => {

      if (item && r === 'row') {
        return item.groupRow == true ? 'group-row' : ''
      } else {
        return null
      }
    }


    const divicesFilterd = (data) => {
      devices.value = data;
    }
    const merageFilterWithRequest = (data) => {
      delete data['type']

      Object.assign(request.value, data);
    }



    const rangeDate = ref('')
    const tableRef = ref(null)

    const { type } = reportForm()

    const { report_data, request, errors, loading, getReport, total, from, to,  isSortDirDesc,sortBy,dataTableloading} = ReportLogic()
    const sortData=(data)=>{
      sortBy.value=data.sortBy
      isSortDirDesc.value=data.isSortDirDesc
    }

    const { devices, filter_request } = FilterLogic()

    const { pickerOptions } = ReportOptions(request.value)

    const report_wrapper = ref(null)

    const filter_included_fields = ['device', 'plan', 'area', 'date', 'day', 'serveCount', 'visit', 'times', 'durations', 'percent','owner','contract']
    const report_fields = [
      {
        key: 'index',
        label: 'id',
        sortable: true
      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true
      },
      {
        key: 'contract',
        label:'contract',
        sortable: true
      },

      {
        key: 'device',
        label: 'device',
        sortable: true
      },
      {
        key: 'plan',
        label: 'plan',
        sortable: true
      },
      {
        key: 'area',
        label: 'area',
        sortable: false
      },
      {
        key: 'date',
        label: 'date',
        sortable: false
      },
      {
        key: 'day',
        label: 'day',
        sortable: false
      },

      {
        key: 'serveCount',
        label: 'serveCount',
        sortable: false
      },

      {
        key: 'visit',
        label: 'visit count',
        sortable: false
      },
      {
        key: 'times',
        label: 'times',
        sortable: false
      },
      {
        key: 'durations',
        label: 'durations',
        sortable: false
      },
      {
        key: 'percent',
        label: 'percent',
        sortable: false
      },
     



    ]

    return {
      report_data, filter_included_fields, report_fields, total, from, to, rangeDate,
      tableRef,
      getReport,
      devices,
      type,
      pickerOptions,
      report_wrapper,
      request,
      loading,
      errors,
      filter_request,
      divicesFilterd,
      merageFilterWithRequest,
      getRowClass,
      sortData,
      dataTableloading
    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

.group-row {
  background-color: #ddd;

}
</style>
